/**
 * The vendor MOQ a buy falls short of, or null when it meets it (or either
 * side is unknown). Only a buyer pack-qty override or a hand-edited quantity
 * can put an engine buy here; the master rounding always floors at the MOQ.
 */
export function belowVendorMinQuantity(
  buyQuantity: number | null | undefined,
  vendorMoqQuantity: number | null | undefined,
): number | null {
  if (buyQuantity == null || vendorMoqQuantity == null) return null;
  if (buyQuantity <= 0 || vendorMoqQuantity <= 0) return null;
  return buyQuantity < vendorMoqQuantity ? vendorMoqQuantity : null;
}
